var render, staticRenderFns
import script from "./delegate_form.vue?vue&type=script&lang=js"
export * from "./delegate_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128e22c0')) {
      api.createRecord('128e22c0', component.options)
    } else {
      api.reload('128e22c0', component.options)
    }
    
  }
}
component.options.__file = "found/views/process/views/instance/form/delegate_form.vue"
export default component.exports